export default function paths(){
    
    return {
        HOME: "/",
        HYR: "/hyr"
    }
}
